import React from "react";
import { useEventPlateId, usePlateEditorState } from "@udecode/plate-core";
import { ToolbarButton, ToolbarButtonProps } from "@udecode/plate-ui-toolbar";
import { insertPageBreak } from "../transforms/insertPageBreak";
import { allowFeatureForTextMessages } from "../../text-message/config";

export const PageBreakToolbarButton = ({
  id,
  ...props
}: ToolbarButtonProps): JSX.Element => {
  const editor = usePlateEditorState(useEventPlateId(id));
  const enabled = allowFeatureForTextMessages(editor);
  return (
    <div className={`${enabled ? "" : "plate-disabled"}`}>
      <ToolbarButton
        onMouseDown={(e) => {
          e.preventDefault();
          insertPageBreak(editor);
        }}
        {...props}
      />
    </div>
  );
};
